import jsLogic from 'json-logic-js'

const DAY_IN_MS = 1000 * 60 * 60 * 24

const isGGSNetwork = (networkId, allowNetworks) => {
    return allowNetworks.includes(Number.parseInt(networkId, 10))
}

const isExpired = (date, delayInDays) => {
    if (typeof date === 'number' && /\d{10}/.test(`${date}`)) {
        date *= 1000 // Convert timestamp to ms
    }

    return Date.now() - date >= delayInDays * DAY_IN_MS
}

export const enhanceJSLogic = () => {
    jsLogic.add_operation('isGGSNetwork', isGGSNetwork)
    jsLogic.add_operation('isExpired', isExpired)
}
